import axios from 'axios';
import { apiRequest, apiDownloadRequest } from './apiRequest';
import { CONST } from '../constant';

/**
 * get Post List
 * @returns {Promise}
 */
export const getPostList = async cid => {
  const result = await apiRequest(`/api/post/list/${cid}`, CONST.api_method.get);
  return result.data;
};

export const getPost = async pid => {
  const result = await apiRequest(`/api/post/${pid}/`, CONST.api_method.get);
  return result.data;
};

export const getPostForEdit = async pid => {
  const result = await apiRequest(`/api/post/edit/${pid}/`, CONST.api_method.get);
  return result.data;
};
export const getPostForInvite = async pid => {
  const result = await apiRequest(`/api/post/invite/${pid}/`, CONST.api_method.get);
  return result.data;
};

export const getShareMembers = async pid => {
  const result = await apiRequest(`/api/post/shares/${pid}/`, CONST.api_method.get);
  return result.data;
};

export const getAnswers = async pid => {
  const result = await apiRequest(`/api/post/answers/${pid}/`, CONST.api_method.get);
  return result.data;
};

export const getSelfAnswer = async pid => {
  const result = await apiRequest(`/api/post/answer-self/${pid}/`, CONST.api_method.get);
  return result.data;
};

export const getEnqueteAnswer = async pid => {
  const result = await apiRequest(`/api/post/answer-enquete/${pid}/`, CONST.api_method.get);
  return result.data;
};

export const deletePost = async pid => {
  const result = await apiRequest(`/api/post/delete/${pid}/`, CONST.api_method.post);
  return result.data;
};

export const createPostNews = async data => {
  const result = await apiRequest(`/api/post/news/create`, CONST.api_method.post, data);
  return result.data;
};

export const createPostFile = async data => {
  const result = await apiRequest(`/api/post/file/create`, CONST.api_method.post, data);
  return result.data;
};

export const createPostSchedule = async data => {
  const result = await apiRequest(`/api/post/schedule/create`, CONST.api_method.post, data);
  return result.data;
};

export const createPostEnquete = async data => {
  const result = await apiRequest(`/api/post/enquete/create`, CONST.api_method.post, data);
  return result.data;
};

export const createPostLife = async data => {
  const result = await apiRequest(`/api/post/life/create`, CONST.api_method.post, data);
  return result.data;
};

export const editPostNews = async data => {
  const result = await apiRequest(`/api/post/news/edit`, CONST.api_method.post, data);
  return result.data;
};

export const editPostFile = async data => {
  const result = await apiRequest(`/api/post/file/edit`, CONST.api_method.post, data);
  return result.data;
};

export const editPostSchedule = async data => {
  const result = await apiRequest(`/api/post/schedule/edit`, CONST.api_method.post, data);
  return result.data;
};

export const editPostEnquete = async data => {
  const result = await apiRequest(`/api/post/enquete/edit`, CONST.api_method.post, data);
  return result.data;
};

export const editPostLife = async data => {
  const result = await apiRequest(`/api/post/life/edit`, CONST.api_method.post, data);
  return result.data;
};

export const fixPostFileUpload = async data => {
  const result = await apiRequest(`/api/post/file/fix`, CONST.api_method.post, data);
  return result.data;
};

export const answerPostNews = async data => {
  const result = await apiRequest(`/api/post/news/answer`, CONST.api_method.post, data);
  return result.data;
};

export const answerPostFile = async data => {
  const result = await apiRequest(`/api/post/file/answer`, CONST.api_method.post, data);
  return result.data;
};

export const downloadPostFile = async (pid, fid, fileName) => {
  return await apiDownloadRequest(`/api/post/file/download/${pid}/${fid}`, fileName);
};

export const answerPostSchedule = async data => {
  const result = await apiRequest(`/api/post/schedule/answer`, CONST.api_method.post, data);
  return result.data;
};

export const answerPostEnquete = async data => {
  const result = await apiRequest(`/api/post/enquete/answer`, CONST.api_method.post, data);
  return result.data;
};

export const answerPostLife = async data => {
  const result = await apiRequest(`/api/post/life/answer`, CONST.api_method.post, data);
  return result.data;
};

export const answerPostAccept = async data => {
  const result = await apiRequest(`/api/post/accept/answer`, CONST.api_method.post, data);
  return result.data;
};

export const answerInvitationAccept = async (pid, data) => {
  const result = await apiRequest(`/api/post/invited/accept/${pid}`, CONST.api_method.post, data);
  return result.data;
};

export const answerInvitationFriendAccept = async pid => {
  const result = await apiRequest(`/api/post/invited/accept-friend/${pid}`, CONST.api_method.post);
  return result.data;
};

export const answerInvitationDecline = async pid => {
  const result = await apiRequest(`/api/post/invited/decline/${pid}`, CONST.api_method.post);
  return result.data;
};

export const answerInvitationChecked = async (pid, data) => {
  const result = await apiRequest(`/api/post/invited/check/${pid}`, CONST.api_method.post, data);
  return result.data;
};

export default {
  getPostList,
  getPost,
  getPostForEdit,
  getPostForInvite,
  getShareMembers,
  getAnswers,
  getSelfAnswer,
  getEnqueteAnswer,
  deletePost,
  createPostNews,
  createPostFile,
  createPostSchedule,
  createPostEnquete,
  createPostLife,
  editPostNews,
  editPostFile,
  editPostSchedule,
  editPostEnquete,
  editPostLife,
  fixPostFileUpload,
  answerPostNews,
  answerPostFile,
  downloadPostFile,
  answerPostSchedule,
  answerPostEnquete,
  answerPostLife,
  answerPostAccept,
  answerInvitationAccept,
  answerInvitationFriendAccept,
  answerInvitationDecline,
  answerInvitationChecked,
};
